import './clients.scss';
import './img/c-clients-1.jpg';
import './img/c-clients-2.jpg';
import './img/c-clients-3.jpg';
import './img/c-clients-4.jpg';
import './img/c-clients-5.jpg';
import './img/c-clients-6.jpg';
import './img/c-clients-7.jpg';
import './img/c-clients-8.jpg';


$(document).ready(function(){
  if ($(".swiper-container--clients").length) {
    var swiper = new Swiper('.swiper-container--clients', { // eslint-disable-line
      slidesPerView: 6,
      spaceBetween: 11,
      speed: 600,
      // centeredSlides: true,
      loop: true,
      // loop: false,
      autoplay: {
        delay: 3500,
      },
      navigation: {
        prevEl: '.clients-carousel__button--prev',
        nextEl: '.clients-carousel__button--next',
      },
      breakpoints: {
        320: {
          slidesPerView: 1,
        },
        480: {
          slidesPerView: 2,
          autoplay: {
            delay: 3000,
          },
        },
        768: {
          slidesPerView: 4,
        },
        1024: {
          slidesPerView: 6,
        },
      },
    });
  }
});